import { Text } from "@chakra-ui/react";
import useForm from "../../../hooks/useForm";
import { useLoginApi } from "../apis";
import { AlertStatus, Box } from "@chakra-ui/react";
import { useSearchParams } from "react-router-dom";
import { useAlert } from "../../../hooks/useAlert";
import { useAppSelector } from "../../../store";
import { useEffect } from "react";
import InfoGropup from "../components/InfoGroup";
import ForgotPassword from "../components/ForgotPassword";

const LoginForm = () => {
  const { loginWithEmailAndPassword } = useLoginApi();
  const { message, loading } = useAppSelector((s) => s.auth);
  const [searchParams] = useSearchParams();
  const { render: AlertRender, showAlert, hideAlert } = useAlert();

  const urlMessage = searchParams.get("message");
  const urlStatus = searchParams.get("status");

  const { render: formRender, setLoading } = useForm<"email" | "password">({
    initialValues: {
      email: {
        type: "email",
        value: "",
        label: "Email Address",
      },
      password: {
        type: "password",
        value: "",
        label: "Password",
        showEye: true,
      },
    },
    inputSize: "lg",
    showLabel: true,
    submitLabel: "Login",
    buttonWidth: "full",
    onSubmit: (data) => {
      loginWithEmailAndPassword(data);
    },
  });

  // Effect to update loading state
  useEffect(() => {
    setLoading(loading);
  }, [loading, setLoading]);

  useEffect(() => {
    if (urlMessage)
      showAlert({
        status: (urlStatus as AlertStatus) || "info",
        message: urlMessage,
      });
    else if (message)
      showAlert({ status: message.status, message: message.value });
    else hideAlert();
  }, [message, urlMessage]);

  return (
    <Box pb={"2rem"}>
      <Text
        my={"1rem"}
        textAlign={"center"}
        fontSize={"2xl"}
        fontWeight={"bold"}
      >
        Login
      </Text>
      <Box mb={"1rem"}>{AlertRender}</Box>
      <InfoGropup
        type="login"
        sx={{
          flexDirection: "column-reverse",
          display: "flex",
        }}
      />
      <Box>{formRender({ Body: <Box mt={".1rem"}></Box> })}</Box>
      <Box mt={".875rem"}>
        <ForgotPassword />
      </Box>
    </Box>
  );
};

export default LoginForm;
